// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { APP_BAR_HEIGHT } from "metabase/nav/constants";

interface AppBarRootProps {
  hasSidebarOpen?: boolean;
}

export const AppBarRoot = styled.div<AppBarRootProps>`
  display: flex;
  align-items: center;
  gap: 1rem;
  height: ${APP_BAR_HEIGHT};
  padding-left: 1.325rem;
  padding-right: 1rem;
  border-bottom: 1px solid
    ${(props) =>
      props.hasSidebarOpen ? "var(--mb-color-border-neutral)" : "transparent"};
  background-color: var(--mb-color-background_page-primary);
  transition: border-bottom-color 200ms ease;

  /* This row's own breakpoint (AppBar.tsx swaps to AppBarSmall below 40em)
     is media-query-based, so — like every other breakpoint in this app — it
     does not respond to browser zoom (confirmed: matchMedia is unaffected by
     CSS zoom). At high zoom on a normal-width window the row can need more
     width than the physical viewport without ever getting the chance to
     switch to the small layout, silently pushing the New/Metabot/app-switcher
     buttons off-screen with no way to reach them (WCAG 1.4.10 Reflow). Give
     it a real horizontal-scroll fallback instead of an invisible cutoff.
     overflow-y hidden keeps this fixed-height row from also gaining a
     vertical scrollbar. */
  overflow-x: auto;
  overflow-y: hidden;
`;

interface AppBarInfoContainerProps {
  isVisible?: boolean;
}

export const AppBarInfoContainer = styled.div<AppBarInfoContainerProps>`
  display: flex;
  min-width: 0;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};
  transition: ${(props) =>
    props.isVisible ? `opacity 0.5s` : `opacity 0.5s, visibility 0s`};
`;
